import React, { useState } from 'react';
import API from '../api/api';
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2'; // ✅ Import SweetAlert2
import "./ForgotPassword.css";

const ForgotPassword = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [question, setQuestion] = useState(null);
  const [answer, setAnswer] = useState("");
  const [newPassword, setNewPassword] = useState("");

  // ✅ Step 1: Fetch Security Question
  const getQuestion = async () => {
    if (!email) {
      Swal.fire({
        icon: "warning",
        title: "Enter Email",
        text: "Please enter your registered email first.",
        confirmButtonColor: "#fe6e03",
      });
      return;
    }

    try {
      const res = await API.post('/admin/forgot-password', { email });
      setQuestion(res.data.question);

      Swal.fire({
        icon: "info",
        title: "Security Question Found!",
        text: "Please answer the security question below.",
        confirmButtonColor: "#fe6e03",
      });
    } catch {
      Swal.fire({
        icon: "error",
        title: "Email Not Found",
        text: "No admin found with this email. Please try again.",
        confirmButtonColor: "#d33",
      });
    }
  };

  // ✅ Step 2: Reset Password
  const resetPassword = async () => {
    if (!answer || !newPassword) {
      Swal.fire({
        icon: "warning",
        title: "Missing Fields",
        text: "Please provide both answer and new password.",
        confirmButtonColor: "#fe6e03",
      });
      return;
    }

    try {
      await API.post('/admin/reset-password', { email, answer, newPassword });

      await Swal.fire({
        icon: "success",
        title: "✅ Password Reset Successful",
        text: "You can now login with your new password.",
        confirmButtonColor: "#fe6e03",
        timer: 1800,
        showConfirmButton: false,
      });

      navigate("/admin/login");
    } catch {
      Swal.fire({
        icon: "error",
        title: "Incorrect Answer",
        text: "Your security answer is incorrect. Please try again.",
        confirmButtonColor: "#d33",
      });
    }
  };

  return (
    <div className="fp-container">
      <div className="fp-card shadow-lg">
        <h3 className="fp-title text-center mb-3">Forgot Password</h3>

        {/* Step 1: Ask for Email */}
        {!question && (
          <>
            <input
              className="form-control fp-input mb-3"
              placeholder="Enter registered email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button className="btn fp-btn w-100" onClick={getQuestion}>
              Continue
            </button>
          </>
        )}

        {/* Step 2: Show Question & Reset Fields */}
        {question && (
          <>
            <p className="fp-question">
              <strong>Security Question:</strong><br />
              {question}
            </p>

            <input
              className="form-control fp-input mb-3"
              placeholder="Your Answer"
              value={answer}
              onChange={(e) => setAnswer(e.target.value)}
              required
            />

            <input
              type="password"
              className="form-control fp-input mb-3"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />

            <button className="btn fp-btn w-100" onClick={resetPassword}>
              Reset Password
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
